import './ProjectData.css';
import './Myproject.css';
import { motion } from 'framer-motion';
import React, { useState } from 'react';

function ProjectData() {
    const [currentElementIndex, setCurrentElementIndex] = useState(0);
    const elements = [
        {
            key: "0",
            label: "ChatWave",
            title: "ChatWave",
            Link: "https://chatwave-s6hh.onrender.com/",
            GitHub: "https://github.com/tusharkaran/ChatWave",
            details: [
                "ChatWave is a multilingual chat application that breaks language barriers with real-time translation, allowing users to communicate seamlessly in different languages."
            ],
            technologies: [
                "MERN",
                "CICD",
                "API"
            ],
            imageSrc: '/images/24370E94-4BA1-46D9-94F7-2D004F359CD8_1_105_c.jpeg',
        },
        {
            key: "1",
            label: "Dictionary World",
            title: "Chrome Extension",
            Link: "https://chromewebstore.google.com/detail/dictionary-world/iedephkbplpicphbfcaofkimdmmadona",
            GitHub: "https://github.com/tusharkaran/Chrome-Extenstion",
            details: [
                "Dictionary World is a Chrome extension offering instant word lookup via typing or double-clicking text. It features customizable settings, stores searched words, and allows CSV downloads for study purposes."
            ],
            technologies: ["ReactJs", "Webpack", "HTML5", "CSS"],
            imageSrc: "/images/EBB87233-9B4A-477A-95CE-90BEE0E7E0D4_1_105_c.jpeg",
        },
        {
            key: "2",
            label: "DigiCare",
            title: "Health Monitoring System",
            Link: "https://digicare.netlify.app/signin",
            GitHub: "https://github.com/tusharkaran/DigiCare",
            details: [
                "Created a real-time health monitoring system for doctors to track patients' vitals, review histories, and schedule video call appointments, enhancing patient care through continuous data access and timely consultations."
            ],
            technologies: [
                "TypeScript",
                "React",
                "Flask",
                "DynamoDB",

            ],
            imageSrc: "/images/digicare.png",
        },
        {
            key: "3",
            label: "Portfolio Website",
            title: "Portfolio Website",
            Link: "https://karandeveloper.web.app/",
            GitHub: "https://github.com/tusharkaran/latestportfolio",
            details: [
                "I designed a portfolio website in Figma and developed it using React, showcasing my projects and skills. It is hosted on Firebase for fast and reliable access and includes interactive features for an engaging user experience."
            ],
            technologies: ["ReactJs", "Firebase", "UIUX"],
            imageSrc: "/images/AD6940FF-B4D1-47A1-BEF9-8EB4D2384013_1_105_c.jpeg",
        },
    ];

    const handleProjectItemClick = (index) => {
        setCurrentElementIndex(index);
    };

    return (
        <>   <h2 class="numbered-heading" >Some Things I’ve Built</h2>
            <div className="welcome-container">
                <div className="welcome-left-section">
                    {elements.map((element, index) => (
                        <motion.div
                            key={element.key}
                            className="myprojects-data"
                            initial={{ rotateY: 180, opacity: 0 }}
                            animate={{ rotateY: currentElementIndex === index ? 0 : 180, opacity: currentElementIndex === index ? 1 : 0 }}
                            transition={{ duration: 0.8 }}
                            style={{ display: currentElementIndex === index ? 'block' : 'none' }}
                        >
                            <div className="project-container">
                                <div className="project">
                                    <div className={`project-content ${index % 2 === 1 ? 'reverse-content' : ''}`}>
                                        <div className={`project-label ${index % 2 === 1 ? 'reverse-label' : ''}`}>
                                            <div class="project-links"><a href={element.GitHub} aria-label="GitHub Link" rel="noopener noreferrer" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-github"><title>GitHub</title><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg></a><a href={element.Link} aria-label="External Link" class="external" rel="noopener noreferrer" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link"><title>External Link</title><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg></a></div>
                                        </div>
                                        <h4 className={`project-title ${index % 2 === 1 ? 'reverse-title' : ''}`}>{element.title}</h4>
                                        <div className="project-details">
                                            <p>
                                                {element.details.map((detail, i) => (
                                                    <li key={i}>{detail}</li>
                                                ))}
                                            </p>
                                            <ul className={`${index % 2 === 1 ? 'reverse-item' : ''}`}>
                                                {element.technologies.map((tech, i) => (
                                                    <li key={i}>{tech}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className={`project-img ${index % 2 === 1 ? 'reverse-img' : ''}`}>
                                        <img src={element.imageSrc} alt={element.title} />
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
                <div className="welcome-right-section">
                    <h2 className="welcome-projects-heading">PROJECTS</h2>
                    <ul className="welcome-projects-list">
                        {elements.map((element, index) => (
                            <li
                                key={index}
                                className="welcome-project-item"
                                onClick={() => handleProjectItemClick(index)}
                            >
                                <a className="welcome-project-link">
                                    <div class="split-text-wrapper">
                                        <div class="upper-text">
                                            <span>{element.label}</span>
                                        </div>
                                        <div class="lower-text">
                                            <span>{element.label}</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

        </>

    );
}

export default ProjectData;
